// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.infobar {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--spacing-quarter);
  padding: var(--spacing-half) var(--spacing);
  border-radius: var(--spacing-quarter);
  background-color: var(--ion-background-color);
  border: 1px solid var(--ion-background-secondary-color);
}
.infobar.--success {
  background-color: var(--ion-color-success);
  border-color: var(--ion-color-success);
  color: var(--ion-color-success-contrast);
}
.infobar.--danger {
  background-color: var(--ion-color-danger);
  border-color: var(--ion-color-danger);
  color: var(--ion-color-danger-contrast);
}
.infobar.--warning {
  background-color: var(--ion-color-warning);
  border-color: var(--ion-color-warning);
  color: var(--ion-color-warning-contrast);
}
.infobar.--info {
  background-color: var(--ion-color-primary);
  border-color: var(--ion-color-primary);
  color: var(--ion-color-primary-contrast);
}`, "",{"version":3,"sources":["webpack://./src/app/general-components/infobar/infobar.component.scss"],"names":[],"mappings":"AACA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,2BAAA;EACA,2CAAA;EACA,qCAAA;EACA,6CAAA;EACA,uDAAA;AAAJ;AAEI;EACI,0CAAA;EACA,sCAAA;EACA,wCAAA;AAAR;AAGI;EACI,yCAAA;EACA,qCAAA;EACA,uCAAA;AADR;AAII;EACI,0CAAA;EACA,sCAAA;EACA,wCAAA;AAFR;AAKI;EACI,0CAAA;EACA,sCAAA;EACA,wCAAA;AAHR","sourcesContent":["\n.infobar {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: var(--spacing-quarter);\n    padding: var(--spacing-half) var(--spacing);\n    border-radius: var(--spacing-quarter);\n    background-color: var(--ion-background-color);\n    border: 1px solid var(--ion-background-secondary-color);\n\n    &.--success {\n        background-color: var(--ion-color-success);\n        border-color: var(--ion-color-success);\n        color: var(--ion-color-success-contrast);\n    }\n\n    &.--danger {\n        background-color: var(--ion-color-danger);\n        border-color: var(--ion-color-danger);\n        color: var(--ion-color-danger-contrast);\n    }\n\n    &.--warning {\n        background-color: var(--ion-color-warning);\n        border-color: var(--ion-color-warning);\n        color: var(--ion-color-warning-contrast);\n    }\n\n    &.--info {\n        background-color: var(--ion-color-primary);\n        border-color: var(--ion-color-primary);\n        color: var(--ion-color-primary-contrast);\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
